<template>
  <tab-layout>
    <cart-form :cartMembers="cartMembers" slot="tabContent" class="tab-pane col-12 col-xl-9 px-0 show active" id="cart" role="tabpanel" aria-label="Cart" />
  </tab-layout>
</template>

<script>

import tabLayout from '@/components/TabLayout'
import CartForm from "./components/CartForm"

export default {
  name: "CommitteeCart",
  components: {
    'tab-layout': tabLayout,
    CartForm
  },
  data() {
    return {
      cartMembers: this.$store.getters.getCartMembers
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/Committees/Cart/Cart.vue